import type React from 'react'
import type { JSX } from 'react'
import type { FIXED_INDENTS } from 'vars/fixed-indents'

import { useMemo } from 'react'
import { CARDS_ASPECT_RATIO } from 'blocks/Cards'
import { CardsInRow } from 'containers/RowContainer'
import { useVisibleCards } from 'containers/RowContainer/hooks'
import { useClientWidth } from 'utils/hooks'
import {
  RowSkeletonContainerSC,
  RowSkeletonInnerSC,
  RowSkeletonItem,
  RowSkeletonTitleSC,
  SkeletonSeeAllSC,
  SkeletonTitleSC,
} from './RowSkeleton.styled'

export interface ISkeletonComponentProps {
  cardsAspectRatio?: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  cardsInRow?: CardsInRow
  visibleCards?: number
  children?: React.ReactNode
  tvChannelCard?: boolean
  withTitle?: boolean
  verticalPaddings?: FIXED_INDENTS
}

export const RowSkeleton = ({
  cardsAspectRatio = CARDS_ASPECT_RATIO.HORIZONTAL_TRIA_DEFAULT,
  cardsInRow = CardsInRow.Horizontal_3,
  tvChannelCard = false,
  withTitle = true,
  verticalPaddings,
  visibleCards,
}: ISkeletonComponentProps): JSX.Element => {
  const clientWidth = useClientWidth()
  const rowDirection = useMemo(() => cardsInRow?.charAt(0), [cardsInRow])
  const visibleCardsCalculated = useVisibleCards({
    clientWidth,
    cardsInRow: +cardsInRow.split('_')[1],
    rowDirection,
    tvChannelCard,
  })

  const countCards = visibleCards ?? visibleCardsCalculated

  return (
    <RowSkeletonInnerSC
      cardsAspectRatio={cardsAspectRatio}
      cardsInRow={countCards}
      verticalPadding={verticalPaddings}
    >
      {Boolean(withTitle) && (
        <RowSkeletonTitleSC>
          <SkeletonTitleSC />
          <SkeletonSeeAllSC />
        </RowSkeletonTitleSC>
      )}
      <RowSkeletonContainerSC>
        {new Array(countCards + 1).fill(' ').map((_, index) => (
          <RowSkeletonItem key={`${cardsInRow}_${index}`} />
        ))}
      </RowSkeletonContainerSC>
    </RowSkeletonInnerSC>
  )
}
